var render = function render(){var _vm=this,_c=_vm._self._c;return _c('h1',{staticClass:"text-xs-center my-4"},[_vm._v("\n  PAGE NOT FOUND\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }